import { Box } from "@mui/joy";
import type { Module } from "../../../../../api/followup/Followup.typed";
import FollowUpCriterionRow from "./FollowUpCriterionRow";
import DarkTypography from "../../../../common/DarkTypography";
import { textTokens } from "../../../../../styles/globalStyles";

type FollowUpModuleSectionProps = {
  module: Module;
  moduleIndex: number;
  onCheckboxChange: (moduleIndex: number, criteriaIndex: number, option: string) => void;
  onRadioChange: (moduleIndex: number, criteriaIndex: number, value: string) => void;
  onResetCriteria: (moduleIndex: number, criteriaIndex: number) => void;
  onAddComment: (moduleIndex: number, criteriaIndex: number, text: string) => void;
  onUpdateComment: (
    moduleIndex: number,
    criteriaIndex: number,
    commentIndex: number,
    text: string,
  ) => void;
  onDeleteComment: (moduleIndex: number, criteriaIndex: number, commentIndex: number) => void;
  userName?: string;
  readOnly?: boolean;
};

export default function FollowUpModuleSection({
  module,
  moduleIndex,
  onCheckboxChange,
  onRadioChange,
  onResetCriteria,
  onAddComment,
  onUpdateComment,
  onDeleteComment,
  userName,
  readOnly = false,
}: FollowUpModuleSectionProps) {
  return (
    <Box mb={4}>
      <DarkTypography
        level="h3"
        sx={{
          color: textTokens.color.inverse,
          marginBottom: 1,
          fontSize: { xs: "1rem", sm: "1.5rem" },
        }}
      >
        {module.name}
      </DarkTypography>

      {module.criteria.map((criteria, criteriaIndex) => (
        <FollowUpCriterionRow
          key={criteriaIndex}
          criteria={criteria}
          moduleIndex={moduleIndex}
          criteriaIndex={criteriaIndex}
          onCheckboxChange={onCheckboxChange}
          onRadioChange={onRadioChange}
          onResetCriteria={onResetCriteria}
          onAddComment={onAddComment}
          onUpdateComment={onUpdateComment}
          onDeleteComment={onDeleteComment}
          userName={userName}
          readOnly={readOnly}
        />
      ))}
    </Box>
  );
}
